"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("es6-promise/auto");
const api_1 = require("./api");
/* eslint-enable @typescript-eslint/no-explicit-any */
/**
 * Fetch search results of search suggestions from the Addsearch API
 */
const executeApiFetch = function (apiHostname, sitekey, type, settings, cb, fuzzyRetry, customFilterObject, recommendOptions) {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const settingToQueryParam = function (setting, key) {
        if (setting || setting === false) {
            return '&' + key + '=' + setting;
        }
        return '';
    };
    /* eslint-enable @typescript-eslint/no-explicit-any */
    // Validate query type
    if (type !== 'search' &&
        type !== 'ai-answers' &&
        type !== 'suggest' &&
        type !== 'autocomplete' &&
        type !== 'recommend') {
        cb({
            error: { response: api_1.RESPONSE_BAD_REQUEST, message: 'invalid query type' }
        });
        return;
    }
    let keyword = '';
    let queryParamsString = '';
    // API Path (eq. /search, /suggest, /autocomplete/document-field)
    let apiEndpoint = null;
    let apiPath = null;
    // Search
    if (type === 'search') {
        // Path
        apiPath = type;
        // Keyword
        keyword = settings === null || settings === void 0 ? void 0 : settings.keyword;
        // Boolean operators (AND, OR, NOT) uppercase
        keyword = (settings === null || settings === void 0 ? void 0 : settings.enableLogicalOperators)
            ? keyword.replace(/ and /g, ' AND ').replace(/ or /g, ' OR ').replace(/ not /g, ' NOT ')
            : keyword.replace(/ AND /g, ' and ').replace(/ OR /g, ' or ').replace(/ NOT /g, ' not ');
        // Escape
        keyword = encodeURIComponent(keyword);
        // Fuzzy
        let fuzzy = settings === null || settings === void 0 ? void 0 : settings.fuzzy;
        if (fuzzy === 'retry') {
            // First call, non fuzzy
            if (fuzzyRetry !== true) {
                fuzzy = false;
            }
            // Second call, fuzzy
            else {
                fuzzy = true;
            }
        }
        queryParamsString =
            settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.lang, 'lang') +
                settingToQueryParam(fuzzy, 'fuzzy') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.collectAnalytics, 'collectAnalytics') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.postfixWildcard, 'postfixWildcard') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.categories, 'categories') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.priceFromCents, 'priceFromCents') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.priceToCents, 'priceToCents') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.dateFrom, 'dateFrom') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.dateTo, 'dateTo') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.paging.page, 'page') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.paging.pageSize, 'limit') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.shuffleAndLimitTo, 'shuffleAndLimitTo') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.jwt, 'jwt') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.resultType, 'resultType') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.userToken, 'userToken') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.numFacets, 'numFacets') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.cacheResponseTime, 'cacheResponseWithTtlSeconds') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.searchOperator, 'defaultOperator') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.analyticsTag, 'analyticsTag');
        // Add sortBy and sortOrder
        if (Array.isArray(settings === null || settings === void 0 ? void 0 : settings.paging.sortBy)) {
            settings === null || settings === void 0 ? void 0 : settings.paging.sortBy.forEach(function (value, index) {
                queryParamsString =
                    queryParamsString +
                        settingToQueryParam(value, 'sort') +
                        settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.paging.sortOrder[index], 'order');
            });
        }
        else {
            queryParamsString =
                queryParamsString +
                    settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.paging.sortBy, 'sort') +
                    settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.paging.sortOrder, 'order');
        }
        // Add custom field filters
        if (settings === null || settings === void 0 ? void 0 : settings.customFieldFilters) {
            for (let i = 0; i < (settings === null || settings === void 0 ? void 0 : settings.customFieldFilters.length); i++) {
                queryParamsString = queryParamsString + '&customField=' + (settings === null || settings === void 0 ? void 0 : settings.customFieldFilters[i]);
            }
        }
        // Add facet fields
        if (settings === null || settings === void 0 ? void 0 : settings.facetFields) {
            for (let i = 0; i < (settings === null || settings === void 0 ? void 0 : settings.facetFields.length); i++) {
                queryParamsString = queryParamsString + '&facet=' + (settings === null || settings === void 0 ? void 0 : settings.facetFields[i]);
            }
        }
        // Range facets
        if (settings === null || settings === void 0 ? void 0 : settings.rangeFacets) {
            queryParamsString =
                queryParamsString +
                    '&rangeFacets=' +
                    encodeURIComponent(JSON.stringify(settings === null || settings === void 0 ? void 0 : settings.rangeFacets));
        }
        // Hierarchical facets
        if (settings === null || settings === void 0 ? void 0 : settings.hierarchicalFacetSetting) {
            queryParamsString =
                queryParamsString +
                    '&hierarchicalFacets=' +
                    encodeURIComponent(JSON.stringify(settings === null || settings === void 0 ? void 0 : settings.hierarchicalFacetSetting));
        }
        // Stats fields
        if (settings === null || settings === void 0 ? void 0 : settings.statsFields) {
            for (let i = 0; i < (settings === null || settings === void 0 ? void 0 : settings.statsFields.length); i++) {
                queryParamsString = queryParamsString + '&fieldStat=' + (settings === null || settings === void 0 ? void 0 : settings.statsFields[i]);
            }
        }
        // Personalization events
        if ((settings === null || settings === void 0 ? void 0 : settings.personalizationEvents) && Array.isArray(settings === null || settings === void 0 ? void 0 : settings.personalizationEvents)) {
            for (let i = 0; i < (settings === null || settings === void 0 ? void 0 : settings.personalizationEvents.length); i++) {
                const obj = settings === null || settings === void 0 ? void 0 : settings.personalizationEvents[i];
                const key = Object.keys(obj)[0];
                queryParamsString =
                    queryParamsString + '&personalizationEvent=' + encodeURIComponent(key + '=' + obj[key]);
            }
        }
        // Filter object
        if (customFilterObject) {
            queryParamsString =
                queryParamsString + '&filter=' + encodeURIComponent(JSON.stringify(customFilterObject));
        }
        else if (settings === null || settings === void 0 ? void 0 : settings.filterObject) {
            queryParamsString =
                queryParamsString + '&filter=' + encodeURIComponent(JSON.stringify(settings === null || settings === void 0 ? void 0 : settings.filterObject));
        }
        apiEndpoint =
            'https://' +
                apiHostname +
                '/v1/' +
                apiPath +
                '/' +
                sitekey +
                '?term=' +
                keyword +
                queryParamsString;
    }
    // Ai Answers
    else if (type === 'ai-answers') {
        // TODO use apiHostname instead of hardcoded URL
        api_1.apiInstance
            .post(`https://${apiHostname}/v2/indices/${sitekey}/conversations`, {
            question: settings === null || settings === void 0 ? void 0 : settings.keyword
        })
            .then(function (response) {
            if (response.data.response) {
                cb(response.data.response);
            }
            else {
                cb({
                    error: {
                        response: api_1.RESPONSE_SERVER_ERROR,
                        message: 'Could not get ai-answers response in the expected data format'
                    }
                });
            }
        })
            .catch(function (error) {
            console.error(error);
            cb({
                error: {
                    response: api_1.RESPONSE_SERVER_ERROR,
                    message: 'invalid server response'
                }
            });
        });
    }
    // Suggest
    else if (type === 'suggest') {
        apiPath = type;
        queryParamsString =
            settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.suggestionsSize, 'size') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.lang, 'language');
        keyword = settings === null || settings === void 0 ? void 0 : settings.suggestionsPrefix;
        apiEndpoint =
            'https://' +
                apiHostname +
                '/v1/' +
                apiPath +
                '/' +
                sitekey +
                '?term=' +
                keyword +
                queryParamsString;
    }
    // Autocomplete
    else if (type === 'autocomplete') {
        apiPath = 'autocomplete/document-field';
        queryParamsString =
            settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.autocomplete.field, 'source') +
                settingToQueryParam(settings === null || settings === void 0 ? void 0 : settings.autocomplete.size, 'size');
        keyword = (settings === null || settings === void 0 ? void 0 : settings.autocomplete.prefix) || '';
        apiEndpoint =
            'https://' +
                apiHostname +
                '/v1/' +
                apiPath +
                '/' +
                sitekey +
                '?term=' +
                keyword +
                queryParamsString;
    }
    else if (type === 'recommend') {
        if ((recommendOptions === null || recommendOptions === void 0 ? void 0 : recommendOptions.type) === 'RELATED_ITEMS') {
            queryParamsString = settingToQueryParam(recommendOptions.itemId, 'itemId');
            apiPath =
                'recommendations/index/' +
                    sitekey +
                    '/block/' +
                    recommendOptions.blockId +
                    '?' +
                    queryParamsString;
        }
        else if ((recommendOptions === null || recommendOptions === void 0 ? void 0 : recommendOptions.type) === 'FREQUENTLY_BOUGHT_TOGETHER') {
            queryParamsString = settingToQueryParam(recommendOptions.itemId, 'itemId');
            apiPath =
                'recommendations/' +
                    sitekey +
                    '?configurationKey=' +
                    recommendOptions.configurationKey +
                    queryParamsString;
        }
        apiEndpoint = 'https://' + apiHostname + '/v1/' + apiPath;
    }
    if (type !== 'ai-answers') {
        api_1.apiInstance
            .get(apiEndpoint)
            .then(function (response) {
            var _a, _b, _c;
            const json = response.data;
            // Search again with fuzzy=true if no hits
            if (type === 'search' &&
                (settings === null || settings === void 0 ? void 0 : settings.fuzzy) === 'retry' &&
                json.total_hits === 0 &&
                fuzzyRetry !== true) {
                executeApiFetch(apiHostname, sitekey, type, settings, cb, true);
            }
            // Fuzzy not "retry" OR fuzzyRetry already returning
            else {
                // Cap fuzzy results to one page as quality decreases quickly
                if (fuzzyRetry === true) {
                    json.total_hits = Math.min((_a = json.total_hits) !== null && _a !== void 0 ? _a : Infinity, (_c = (_b = settings === null || settings === void 0 ? void 0 : settings.paging) === null || _b === void 0 ? void 0 : _b.pageSize) !== null && _c !== void 0 ? _c : Infinity);
                }
                // Callback
                cb(json);
            }
        })
            .catch(function (error) {
            console.error(error);
            cb({
                error: {
                    response: api_1.RESPONSE_SERVER_ERROR,
                    message: 'invalid server response'
                }
            });
        });
    }
};
exports.default = executeApiFetch;
//# sourceMappingURL=apifetch.js.map